import styled from "styled-components";
import { WelcomeBg } from "../styled/AllImages";


export const WelcomeWrapper = styled.div`
    background-image: url(${WelcomeBg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    width: 100%;
    height: 100%;
    padding-top: 95px;
    flex-direction: column;

    .negMarginBot {
        margin-bottom: 0px;
    }
    .marginBot {
        margin-bottom: 50px;
    }
    
    justify-content: space-between;
    .welcomeWrapperInner{
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      /* align-items: center; */
    }
	.welcomHeadTxt{
		padding-left: 250px;
    	padding-right: 250px;
		@media (max-width: 1730px) {
			&{
				padding-left: 180px;
    			padding-right: 180px;
			}
		}
		@media (max-width: 1499px) {
			&{
				padding-left: 140px;
    			padding-right: 140px;
			}
		}
		@media (max-width: 1299px) {
			&{
				padding-left: 110px;
    			padding-right: 110px;
			}
		}
        @media (max-width: 1199px) {
			&{
				padding-left: 60px;
    			padding-right: 60px;
			}
		}
	}
    .logSignImgWrapper{
        display: flex;
        width: 100%;
        justify-content: center;
        margin-top: 10px;
		    margin-bottom: 20px;
        /* height: 100%; */
        .logSignImg{
            display: flex;
            border-radius: 90px;
            flex-direction: column;
            justify-content: center;
            /* &.logSignImgBorder{
              border: 1px dashed var(--themeColorSecondary);
            } */
        }
    }
	

`;
export const AuthfooterWrapper = styled.div`
    .nav-bar-list-footer{
        padding-bottom: 10px;
        ul{
            display: flex;
            width: 100%;
            justify-content: center;
            gap: 20px;
            a{
                font-size: 14px;
                color: var(--themeColor);
                &:hover{
                    color: var(--themeColorSecondary);
                }
            }
        }
    }
    .copyRight{
        display: flex;
        justify-content: center;
        padding-bottom: 15px;
        .copyRightText{
            text-align: center;
            font-size: 13px;
            color: var(--themeColor);
        }
    }
`;